import { Link } from 'react-router-dom';
import { useGetSettingQuery } from '../../../../Redux/Apis/siteApi';

function Features() {
	const {data : {home: {features : {data,name,caption}}}} = useGetSettingQuery()

    return ( 
        <div className="we-help-section">
			<div className="container">
				<div className="row justify-content-between">
					<div className="col-lg-7 mb-5 mb-lg-0">
						<div className="imgs-grid">
							<div className="grid grid-1"><img src={data.img_1} alt=""/></div>
							<div className="grid grid-2"><img src={data.img_2} alt=""/></div>
							<div className="grid grid-3"><img src={data.img_3} alt=""/></div>
						</div>
					</div>
					<div className="col-lg-5 ps-lg-5">
						<h2 className="section-title mb-4">{name}</h2>
						<p>{caption}</p>

						<ul className="list-unstyled custom-list my-4 px-0">
							{data.txe_1 && <li>{data.txe_1}</li>}
							{data.txe_2 && <li>{data.txe_2}</li>}
							{data.txe_3 && <li>{data.txe_3}</li>}
							{data.txe_4 && <li>{data.txe_4}</li>}
						</ul>
						{data.btn_button1 && <p><Link to={data.btn_button1.key} className="btn">{data.btn_button1.value}</Link></p>}
					</div>
				</div>
			</div>
		</div>
    );
}

export default Features;